import React, { useState } from 'react';
import { Form, Modal, notification } from 'antd';
import moment from 'moment';
import 'moment/locale/es-mx';

import config from '../../config.json';
import { createCustomer } from '../../services/customerService'
import CustomerForm from './CustomerForm';
import { nullifyEmptyStrings } from './../../utils/object';

function CustomerModal(props) {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleCancel = () => {
        props.onCancel();
        form.resetFields();
    }

    const onOkHandler = () => {
        form.validateFields()
        .then(async (values) => {
            setLoading(true);
            
            let birthDate = null;
            if (values.birthDate)
                birthDate = moment(values.birthDate.startOf('day')).format();

            // Nullify empty strings
            nullifyEmptyStrings(values);
            
            try {
                const { data } = await createCustomer({ ...values, birthDate, clientGroupId: config.clientGroups.general });
                form.resetFields();
                props.onOk(data);
                notification.success({ message: 'Clientes', description: 'Se creó el cliente.' });
            } finally {
                setLoading(false);
            }
        }).catch(() => { });
    }

    return <Modal
        title="Nuevo Cliente"
        open={props.visible}
        cancelText="Cancelar"
        onCancel={handleCancel}
        onOk={onOkHandler}
        confirmLoading={loading}
        okText="Guardar"
        width={1000}>
            <CustomerForm form={form} initialValues={{ rfc: 'XAXX010101000' }} />
    </Modal>;
}

export default CustomerModal;